<div class="card card-login">
    <div class="card-content">
      <div class="row" *ngIf="!removeLogo">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3>2-Step verification</h3>
          </div>
        </div>
      </div>
      <sms-authentication
        *ngIf="viewToDisplay=='smsAuthentication'"
        (continue)="changedPhoneAndSendCode($event)"
        (back)="changeView('authenticate')"
      ></sms-authentication>
      <verify-code
        *ngIf="viewToDisplay=='authenticate'"
        [setup]="false" [smsEnabled]="smsEnabled"
        [userConfig]="userConfig"
        (methodSwitched)="onMethodSwitched()"
        (logoHidden)="removeLogoFromView($event)"
        (changePhoneNo)="changePhoneNo()"
        (changeDevice)="changeDevice()"
        (deviceConfirmSuccess)="showDeviceConfirmPage()"
      ></verify-code>
      <app-setup-success *ngIf="viewToDisplay=='deviceConfirmed'" (sendCode)="sendVerificationCode()"></app-setup-success>
    </div>

    <div class="footer text-center" *ngIf="!removeLogo">
      <p class="small">
        <a routerLink="/login" routerLinkActive="active">
          Sign in with a different account</a>
      </p>
    </div>
</div>
